import BackToResultButton from 'components/common/BackToResultButton';
import BannerContainer from 'components/layout/BannerContainer';
import BannerText from 'components/layout/BannerText';
import BannerTitle from 'components/layout/BannerTitle';
import { Container } from 'components/saved-credits/SavedCreditsBanner/components';
import FlexContainer from 'components/common/FlexContainer';
import { Spin } from 'antd';
import { globalStyles } from 'styles/theme';
import useTranslation from 'hooks/use-translation';

export default function SavedCreditsBanner(): JSX.Element {
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    <BannerContainer className='banner-container'>
      <Container className='saved-credits-banner-container'>
        <FlexContainer className='saved-credits-back-button-container' alignSelf='flex-start'>
          <BackToResultButton color={globalStyles.colors.white} />
        </FlexContainer>
        <BannerTitle className='banner-title'>{translation.saved.title}</BannerTitle>
        {translation.saved.description.length > 0 && (
          <FlexContainer className='saved-credits-banner-text-container'>
            {translation.saved.description.map((description) => (
              <BannerText className='banner-text' key={description}>
                {description}
              </BannerText>
            ))}
          </FlexContainer>
        )}
      </Container>
    </BannerContainer>
  );
}
